<template>
    <div class="site-right">
        <boxTitle :title="'站点信息'" :subtitle="'Site information'"></boxTitle>
        
        <div class="site-info">
            <div>
                <div class="info-item">
                    <div class="item-label">站点名称：</div>
                    <div class="item-value">{{ stationInfo.stationName }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">站点类型：</div>
                    <div class="item-value">{{ stationInfo.stationType }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">站点省市：</div>
                    <div class="item-value">{{ stationInfo.city }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">建站日期：</div>
                    <div class="item-value">{{ stationInfo.constructionTime }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">占地面积：</div>
                    <div class="item-value">{{ stationInfo.siteArea }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">开站日期：</div>
                    <div class="item-value">{{ stationInfo.serviceDate }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">匹配车型：</div>
                    <div class="item-value">{{ stationInfo.vehicleBrand }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">服务能力：</div>
                    <div class="item-value">{{ stationInfo.serviceCapacity }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">车位数量：</div>
                    <div class="item-value">{{ stationInfo.carNum }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">额定电池：</div>
                    <div class="item-value">{{ stationInfo.batteryNum }}</div>
                </div>
            </div>
        </div>

        <divBox class="mt-50" style="height: 420px" :title="'换电次数'">
            <template>
                <leftvtrendlicheng
                    v-if="vtrendChartsShow"
                    :id="'siteVtrendCharts'"
                    :xData="curDate"
                    :colors="['#3FFFD9', '#60F5FF']"
                    :data="chargeNum" />
            </template>
        </divBox>
        
        <divBox class="mt-50" style="height: 420px" :title="'换电里程'">
            <template>
                <leftvtrendlicheng
                    v-if="vtrendChartsShow"
                    :id="'siteTempCharts'"
                    :xData="curDate"
                    :data="chargeMileage" />
            </template>
        </divBox>

    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'
// import boxList from '../../components/boxList.vue'
import leftvtrendlicheng from './left-vtrend-licheng.vue'

import { dataInterface } from "@/api/dataInterfaceApi"

export default {
    components: {
        boxTitle,
        divBox,
        // boxList,
        leftvtrendlicheng
    },
    data() {
        return {
            stationInfo: {},
            curDate: [], // 7天日历
            chargeNum: [], // 7天换电次数
            chargeMileage: [], // 7天换电里程
            vtrendChartsShow: false,
            stationId: '',
        }
    },
    inject: ['stationObj'],
    computed: {
        computedProperty() {
            return this.stationObj()
        }
    },
    watch: {
        computedProperty(val) {
            this.stationId = val.value
            this.vtrendChartsShow = false

            this.curDate = [], // 7天日历
            this.chargeNum = [], // 7天换电次数
            this.chargeMileage = [], // 7天换电里程
		    this.init()
        },
    },
    mounted() {
		// let val = this.stationObj()

		// this.stationId = val.value
		// this.stationName = val.name
		
		// this.init()
    },
    methods: {
        async init() {
            // 站点-站点信息
            this.stationxinxi()
            // 近7天换电里程/换电电量趋势
            this.dayhuandianlichengdianliang()
        },
        // 站点-站点信息
        stationxinxi() {
            let params = {
                "enCode": "TiDB-Energy-zhandian-stationxinxi",
                "@station_id": this.stationId
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('stationxinxi============', res)
                    if(!res || !res.length || !res[0]) return {}
                    this.stationInfo = res[0]
                })
                .catch((err) => {
                    console.log(err);
                })
        },
        // 近7天换电里程/换电电量趋势
        dayhuandianlichengdianliang() {
            let newDate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))
            let params = {
                "enCode": "TiDB-Energy-zhandian-7dayhuandianlichengdianliang",
                "@station_id": this.stationId,
                "@curDate": `${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()}`
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('dayhuandianlichengdianliang======', res)
                    if(!res || !res.length ) return
                    this.setData(res)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        setData(data) {
            console.log('dayhuandianlichengdianliang======', data)
            data.map( item => {
                this.curDate.push(item.curDate.slice(5, 10))
                this.chargeNum.push(parseFloat(item.chargeNum || 0, 10))
                this.chargeMileage.push(parseFloat(item.chargeMileage || 0, 10))
            })
            this.vtrendChartsShow = true
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../comm.scss';
.site-right {
    margin-top: 20px;
    .site-info {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        > div {
            width: 50%;
            box-sizing: border-box;
            &:nth-child(odd) {
                padding-right: 5px;
            }
            &:nth-child(even) {
                padding-left: 5px;
            }
            padding-bottom: 10px;
        }
        .info-item {
            background: #01B1A9 linear-gradient(180deg, rgba(14,134,139,0.88) 0%, rgba(0,43,41,0.6) 100%);
            height: 60px;
            font-size: 20px;
            display: flex;
            align-items: center;
            .item-label {
                width: 115px;
                flex-shrink: 0;
                // display: flex;
                text-align: right;
                white-space: nowrap;
                &.w1 {
                    width: 140px;
                }
            }
            .item-value {
                flex: 1;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }

    .power-chart {
        margin-top: 6px;
    }
}
</style>